import { NavLink, useNavigate } from 'react-router-dom'
import { useGarden } from '../context/GardenContext'

const steps = [
  { to: '/', label: 'Region', short: 'OR/WA' },
  { to: '/setup', label: 'Containers', short: 'Pots' },
  { to: '/browse', label: 'Plants', short: 'Plants' },
  { to: '/design', label: 'Design', short: 'Design' },
  { to: '/lists', label: 'List', short: 'List' },
]

export default function NavBar() {
  const navigate = useNavigate()

  return (
    <nav className="grass-bg text-ac-cream">
      <div className="max-w-5xl mx-auto px-4 py-3 flex items-center justify-between gap-4">
        <button
          onClick={() => navigate('/')}
          className="font-pixel text-sm text-ac-cream hover:text-ac-yellow transition-colors whitespace-nowrap"
        >
          TinyPlanter
        </button>

        <ol className="flex items-center gap-1">
          {steps.map((step, i) => (
            <li key={step.to} className="flex items-center">
              {i > 0 && <span className="text-ac-cream/40 mx-0.5 text-xs hidden sm:block">/</span>}
              <NavLink
                to={step.to}
                end={step.to === '/'}
                className={({ isActive }) =>
                  `font-body font-bold text-xs px-2 py-1 rounded-lg transition-all ${
                    isActive
                      ? 'bg-ac-cream text-ac-green-dark shadow-ac-sm'
                      : 'text-ac-cream/80 hover:text-ac-cream hover:bg-ac-cream/20'
                  }`
                }
              >
                <span className="hidden sm:inline">{step.label}</span>
                <span className="sm:hidden">{step.short}</span>
              </NavLink>
            </li>
          ))}
        </ol>

      </div>
    </nav>
  )
}
